import {
  IWorkflowLike,
  IWorkflowStepLike,
} from 'src/app/workflows/useWorkflowStatusFilters';

export interface IWorkflowStepSource {
  workflow?: IWorkflowLike;
}

/**
 * @registry Merges the step lists of many items that each carry their own workflow into a single pseudo-workflow whose steps are the distinct step labels in first-seen order across all items. Feed the result as the `currentWorkflow` to useWorkflowStatusFilters/useWorkflowStatusSegments when a list spans jobs with different workflows; per-item colors still resolve from each item's own workflow.steps. Labels are deduped by exact string; empty labels are skipped.
 */
export function mergeWorkflowSteps(
  items: IWorkflowStepSource[],
): IWorkflowLike {
  const seen = new Set<string>();
  const steps: IWorkflowStepLike[] = [];

  for (const item of items) {
    for (const step of item.workflow?.steps ?? []) {
      const label = step.label;
      if (label && !seen.has(label)) {
        seen.add(label);
        steps.push({ label, buttonColor: step.buttonColor });
      }
    }
  }

  return { steps };
}
